module.exports = __webpack_public_path__ + "img/avatar0.931d0d95.png";